import { httpBodyArg, httpPost, httpRoute } from '../infrastructure/http/http-decorators';
import { LocalizedString } from '../dto/localized-string';

export interface BuyMeCoffeeWebhookData {
	id: number;
	amount: number;
	object: string;
	paused: string;
	status: string;
	canceled: string;
	currency: string;
	psp_id: string; // Payment Service Provider ID (Stripe subscription ID)
	duration_type: string;
	membership_level_id: number;
	membership_level_name: string;
	started_at: number | null;
	canceled_at: number | null;
	note_hidden: boolean;
	support_note: string | null;
	supporter_name: string;
	supporter_id: number;
	supporter_email: string;
	current_period_end: number | null;
	current_period_start: number | null;
	supporter_feedback?: string | null;
	cancel_at_period_end?: string | null;
	[key: string]: unknown;
}

export interface BuyMeCoffeeWebhookEvent {
	type: string; // e.g., "membership.started", "membership.renewed"
	live_mode: boolean;
	attempt: number;
	created: number;
	event_id: number;
	data: BuyMeCoffeeWebhookData;
}

export interface BuyMeCoffeeWebhookResponse {
	success: boolean;
	message: LocalizedString;
}

@httpRoute('/api/buy-me-coffee')
export abstract class IBuyMeCoffeeMembershipService {
	/**
	 * Webhook endpoint for Buy Me Coffee events.
	 *
	 * NOTE: We intentionally model parameters to match Buy Me Coffee's raw JSON payload keys,
	 * so the default POST argument resolver can map fields directly from `req.body`.
	 */
	@httpPost('web-hook')
	onEvent(
		@httpBodyArg() data: BuyMeCoffeeWebhookEvent
	): Promise<BuyMeCoffeeWebhookResponse> {
		void data;
		throw new Error('Not implemented');
	}
}

